import { SVGFC } from '@repo/toolkit/types'

const PushChevronIcon: SVGFC = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.64869 12.6665C4.49194 12.6665 4.34049 12.6082 4.22235 12.5023C4.10421 12.3964 4.02737 12.2501 4.00605 12.0905L4 11.9998L4 3.99965C4.00005 3.83073 4.06249 3.66814 4.17469 3.54471C4.2869 3.42129 4.44051 3.34623 4.60448 3.33472C4.76845 3.32321 4.93057 3.37609 5.05806 3.48269C5.18556 3.58928 5.26893 3.74164 5.29134 3.90898L5.29739 3.99965L5.29739 11.9998C5.29739 12.1766 5.22905 12.3462 5.10739 12.4712C4.98574 12.5963 4.82074 12.6665 4.64869 12.6665ZM11.8103 12.4709C11.7005 12.5839 11.5548 12.6525 11.3999 12.6644C11.245 12.6763 11.0911 12.6307 10.9661 12.5358L10.8935 12.4709L7.0013 8.47086C6.89143 8.35798 6.82464 8.20832 6.81305 8.04911C6.80146 7.8899 6.84586 7.7317 6.93816 7.60328L7.0013 7.52861L10.8935 3.52853C11.0094 3.41034 11.1644 3.34142 11.3275 3.33551C11.4907 3.32961 11.65 3.38715 11.7737 3.49667C11.8974 3.60618 11.9764 3.75961 11.9949 3.92633C12.0134 4.09305 11.97 4.2608 11.8734 4.3961L11.8103 4.47077L8.37653 7.99974L11.8103 11.5287C11.9318 11.6537 12 11.8232 12 11.9998C12 12.1765 11.9318 12.3459 11.8103 12.4709Z" />
    </svg>
  )
}

export default PushChevronIcon
